// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T_-O","field":"styles_field__3lcaO","fieldCol":"styles_fieldCol__615zh","diffCol":"styles_diffCol__1nSdm","diff":"styles_diff__tElrT"};